import { WOOTDASH_BASE } from '@/api/wootdash'

// Agent.AvatarUrl/Contact.AvatarUrl guardam o valor cru de POST /anexos — um caminho
// RELATIVO (ex: "2026/09/<guid>.jpg"), não uma URL pronta para <img src>. Precisa do
// prefixo /anexos/ (servido sem auth, ver AttachmentEndpoints.cs) pra virar exibível.
// Valores já absolutos (http/https/data — ex: avatar importado do Chatwoot com URL
// própria) passam direto, sem prefixar.
export function toMediaUrl(path: string | null | undefined): string | null {
  if (!path) return null
  if (/^(https?:)?\/\//.test(path) || path.startsWith('data:')) return path
  return `${WOOTDASH_BASE}/anexos/${path.replace(/^\/+/, '')}`
}
